<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Информация"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Информация'},
    data: () => ({
      subnav: [
        {
          text: 'Реквизиты',
          to: '/admin/info',
          exact: true,
        },
        {
          text: 'Пользовательское соглашение',
          to: '/admin/info/agreement',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/info.vue